import React from 'react';
import { parseThemeColor } from '../../utils/theme-helper.js';

const resolveColor = (key) => {
    if (!key) return undefined;
    const rgbValue = parseThemeColor(key);
    if (rgbValue) return `rgb(${rgbValue.replace(/ /g, ', ')})`;
    return key;
};

export const TextBehavior = {
  id: 'Text',
  label: 'Typography',
  icon: 'Typography',
  description: 'Renders text content within the box.',
  fields: [
    { name: 'content', label: 'Content', type: 'text', default: 'New Text' },
    { name: 'tag', label: 'HTML Tag', type: 'select', options: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'span'], default: 'span' },
  ],
  renderContent: (props, isLiveMode, variantClasses, variantContentStyle) => {
    // Wrap text content in an inner element (same pattern as Image)
    // This allows the wrapper div to accept children without breaking text rendering
    const Tag = props.tag || 'span';
    return React.createElement(Tag, {
      className: variantClasses || '',
      style: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'inherit',
        justifyContent: 'inherit',
        ...(variantContentStyle || {})
      }
    }, props.content || '');
  }
};

export const ImageBehavior = {
  id: 'Image',
  label: 'Image',
  icon: 'Image',
  description: 'Renders an image from a URL.',
  fields: [
    { name: 'src', label: 'Source URL', type: 'text', default: 'https://picsum.photos/200/200' },
    { name: 'objectFit', label: 'Fit Mode', type: 'select', options: ['cover', 'contain', 'fill'], default: 'cover' },
    { name: 'opacity', label: 'Opacity', type: 'number', default: 1, step: 0.1 }
  ],
  renderContent: (props, isLiveMode, variantClasses, variantContentStyle) => React.createElement('img', {
      src: props.src,
      alt: 'content',
      style: {
          width: '100%',
          height: '100%',
          objectFit: props.objectFit || 'cover',
          borderRadius: 'inherit',
          opacity: props.opacity !== undefined ? props.opacity : 1,
          pointerEvents: 'none' // Let the box handle clicks
      }
  })
};

export const ButtonBehavior = {
  id: 'Button',
  label: 'Button Interaction',
  icon: 'Button',
  description: 'Adds interactive button states.',
  fields: [],
  getStyle: (props, isLiveMode) => {
      const base = {
          transition: 'transform 0.1s, filter 0.1s'
      };
      return base;
  }
};

export const InputBehavior = {
  id: 'Input',
  label: 'Text Input',
  icon: 'Input',
  description: 'Renders an interactive HTML input field.',
  fields: [
    { name: 'placeholder', label: 'Placeholder', type: 'text', default: 'Enter text...' },
    { name: 'defaultValue', label: 'Default Value', type: 'text', default: '' },
    { name: 'textColor', label: 'Text Color', type: 'color', default: 'text' },
  ],
  renderContent: (props, isLiveMode, variantClasses, variantContentStyle) => {
      if (!isLiveMode) {
          return React.createElement('div', {
              className: 'w-full h-full flex items-center px-2 text-sm opacity-50 truncate',
              style: { color: resolveColor(props.textColor || 'text') }
          }, props.defaultValue || props.placeholder || '');
      }
      return React.createElement('input', {
          type: 'text',
          placeholder: props.placeholder,
          defaultValue: props.defaultValue,
          className: 'w-full h-full bg-transparent border-none outline-none px-2 text-sm',
          style: { color: resolveColor(props.textColor || 'text') }
      });
  }
};

export const DataBindingBehavior = {
    id: 'DataBinding',
    label: 'Data Binding',
    icon: 'Database',
    description: 'Manages exported fields for this Prefab.',
    fields: [
        // 'binding_list' is a custom type handled specifically by the PropertyPanel
        { name: 'bindings', label: 'Bindings', type: 'binding_list', default: [] }
    ],
    renderContent: () => null 
};
